import { authHeader, BASE_URL, handleResponse, handleResponseBlob } from '@helpers/api';

export const inboxService = {
    getHistory,
    sendMessage,
    resendMessage,
    downloadMessageImage,
    uploadFile,
    sendTypingStatus,
    sendWhatsAppTemplate,
};

function getHistory(conversationId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/${conversationId}/messages`, requestOptions).then(handleResponse);
}

function sendMessage(conversationId, message) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({ conversationId, message }),
    };
    return fetch(`${BASE_URL}api/inbox/messages`, requestOptions).then(handleResponse);
}

function resendMessage(messageId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/inbox/messages/${messageId}:resend`, requestOptions).then(handleResponse);
}

function downloadMessageImage(url) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/assets/download-message-image?url=${url}`, requestOptions).then(handleResponseBlob);
}

function uploadFile(data) {
    const user = JSON.parse(localStorage.getItem('user'));
    const requestOptions = {
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + user.token,
        },
        body: data,
    };
    return fetch(`${BASE_URL}api/inbox/messages/attachments`, requestOptions).then(handleResponse);
}

function sendTypingStatus(conversationId, isTyping) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/${conversationId}:typing?typing=${isTyping}`, requestOptions).then(
        handleResponse,
    );
}

function sendWhatsAppTemplate(conversationId, templateId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };
    return fetch(
        `${BASE_URL}api/inbox/conversations/${conversationId}:open-window?whatsAppTemplateId=${templateId}`,
        requestOptions,
    ).then(handleResponse);
}
